import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SCREEN_TYPE_PRE_REGISTRATION_MANAGEMENT } from '@utils/constants/enums';

const initialState: PreRegistrationState = {
  screenModePreRegistration: SCREEN_TYPE_PRE_REGISTRATION_MANAGEMENT.list,
};

const reducers = {
  setScreenModePreRegistration: (
    state: PreRegistrationState,
    action: PayloadAction<SCREEN_TYPE_PRE_REGISTRATION_MANAGEMENT>
  ) => {
    state.screenModePreRegistration = action.payload;
  },
  setInit: () => initialState,
};

export const preRegistrationSlice = createSlice({
  name: 'preRegistrationManagement',
  initialState,
  reducers,
});
export const { setScreenModePreRegistration, setInit } =
  preRegistrationSlice.actions;

export default preRegistrationSlice.reducer;
